<script lang="ts">
    import src from './svg/calendar_today_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click />
